import { useMutation } from "@tanstack/react-query";
import { updateBrevoCredentials } from "../../api/bBrevoApi";

export const useUpdateBrevo = () => {
  return useMutation({
    mutationKey: ["update-brevo"],
    mutationFn: (data) => updateBrevoCredentials(data),
    onError: (error) => {
      console.error("Brevo update error details:", error.response || error);
    },
  });
};
